import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

import { useMFEContext } from '~/components/MFEProvider';
import { getSelectedHostingId } from '~/utils/hosting/helpers';

import RenderCard from './RenderCard';

const SSHAccess = ({
  sshKey,
  hostingPlanId = undefined,
  backReference = undefined,
}: {
  sshKey: string;
  hostingPlanId?: string | undefined;
  backReference?: string;
}) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });

  const {
    // @ts-expect-error
    updateMFEContext,
  } = useMFEContext();

  // @ts-ignore
  const navigate = useNavigate();

  const handleUpdateHostingId = (id?: string) => {
    const hostingId = getSelectedHostingId(id, backReference);
    updateMFEContext(hostingId);
    navigate(`/ssh-keys`);
  };

  return (
    <RenderCard
      title={t('sshAccess.title')}
      value={sshKey}
      action={
        <Button
          size="small"
          fullWidth
          variant="outlined"
          onClick={() => handleUpdateHostingId(hostingPlanId)}
        >
          {t('manageBtn')}
        </Button>
      }
      tooltip={t('sshAccess.tooltip')}
      dataTestId="ssh-access-card"
      showCopyIcon={true}
    />
  );
};

export default SSHAccess;
